import React, { useEffect, useState, useRef } from "react";
import "./bothquote.css";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import nodata from "../../assets/nodatafound.jpg";
function ImageQuote({ selectedTool, setSelectedTool }) {
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);

  const [currentCategory, setCurrentCategory] = useState("");
  const [imageIndex, setImageIndex] = useState(0);
  const [totalImages, setTotalImages] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const myloc = useLocation().state;
  const [categoryIndex, setCategoryIndex] = useState(0);

  useEffect(() => {
    axios
      .post(
        "https://periodscalendar.preggyzone.com/api/Image/category_list_by_app_id",
        { app_id: 2 }
      )
      .then((response) => {
        setCategories(response.data.data);

        if (response.data.data.length > 0) {
          const defaultCategory = response.data.data[0].category_id;
          fetchImagesByCategory(defaultCategory, 0);
        }
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);
  const fetchImagesByCategory = (category_id, startIndex = 0) => {
    axios
      .post(
        "https://periodscalendar.preggyzone.com/api/Image/images_list_by_category_id",
        { images_category_id: category_id }
      )
      .then((response) => {
        const imageData = response.data.data;

        if (imageData && imageData.length > 0) {
          setTotalImages(imageData.length);
          const paginatedImages = imageData.slice(startIndex, startIndex + 10);
          setImages((prevImages) =>
            startIndex === 0
              ? paginatedImages
              : [...prevImages, ...paginatedImages]
          );
        } else {
          setImages([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
      });
  };

  const handleLoadMore = () => {
    const nextIndex = imageIndex + 10;
    if (nextIndex < totalImages) {
      fetchImagesByCategory(currentCategory, nextIndex);
      setImageIndex(nextIndex);
    }
  };

  const handleCategoryClick = (category_id) => {
    setCurrentCategory(category_id);
    setImageIndex(0);
    fetchImagesByCategory(category_id, 0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleDownload = async (imageUrl) => {
    try {
      console.log("Downloading image from:", imageUrl);
  
      const response = await fetch(imageUrl, { mode: "cors" });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `quote-${Date.now()}.jpg`);
  
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      // Delay revoking the object URL to ensure the download completes
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 2000); // Wait 2 seconds before revoking
    } catch (error) {
      console.error("Error downloading the image:", error);
      alert("Failed to download the image. Please try again.");
    }
  };
  

  const handleShare = async (imageUrl) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out this image quote!",
          url: imageUrl,
        });
      } catch (error) {
        console.error("Error sharing image:", error);
      }
    } else {
      alert("Sharing is not supported in your browser.");
    }
  };

  useEffect(() => {
    if (myloc?.category_id) {
      setCurrentCategory(myloc.category_id);
    }
  }, []);

  const scrollRef = useRef(null);
  const [scrolling, setScrolling] = useState(true);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollInterval;

    if (scrollContainer && scrolling) {
      scrollInterval = setInterval(() => {
        if (
          scrollContainer.scrollLeft + scrollContainer.clientWidth >=
          scrollContainer.scrollWidth
        ) {
          scrollContainer.scrollLeft = 0;
        } else {
          scrollContainer.scrollLeft += 200;
        }
      }, 2000);
    }

    return () => clearInterval(scrollInterval);
  }, [scrolling]);

  return (
    <div className="imageqt-base">
      <div className="imageqt-main" style={{ borderRadius: "30px" }}>
        <div className="bread-container" style={{ paddingBottom: "0px" }}>
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/quotes" className="breadcrumb-link">
                  Quotes
                </Link>
              </li>
              <li className="breadcrumblist active">Image Quotes</li>
            </ol>
          </nav>
        </div>
        <div className="imageqt-bt">
          <h1
            className="title"
            style={{ textAlign: "center", textTransform: "initial" }}
          >
            Image Quotes
          </h1>
        </div>

        <div className="cat-contain" style={{}}>
          <div className="categories">
            {categories.length > 0 ? (
              categories.map((category, index) => (
                <div
                  key={category.id}
                  className={`category-btn ${
                    currentCategory == category.category_id
                      ? "active-category"
                      : ""
                  } ${index === 1 ? "first-category" : ""}`}
                  onClick={() => handleCategoryClick(category.category_id)}
                >
                  {category.category_name}
                </div>
              ))
            ) : (
              <>
                <div className="ndf-container">
                  <img src={nodata} alt="No-Data-Found" id="no-data-found" />
                  <h4 style={{ marginTop: "20px" }}>No Results Found</h4>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="ct-img-load pb-5">
          <div className="imageqt-images">
            {images.length > 0 ? (
              images.map((image, index) => (
                <div
                  key={index}
                  className="image-item"
                  onClick={() => openModal(image.image)}
                >
                  {image ? (
                    <img
                      src={image.image}
                      alt={`quote ${index}`}
                      className="image"
                    />
                  ) : (
                    <p>Image not available</p>
                  )}
                </div>
              ))
            ) : (
              <>
                <div className="ndf-container">
                  <h4 style={{ marginTop: "20px" }}>
                    No images found for this category.
                  </h4>
                </div>
              </>
            )}
          </div>

          <div className="d-flex justify-content-center">
            {imageIndex + 10 < totalImages && (
              <button className="load-more-btn" onClick={handleLoadMore}>
                Load More...
              </button>
            )}
          </div>
        </div>
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={closeModal}>
              &times;
            </span>
            <img
              src={selectedImage}
              alt="Selected Quote"
              className="modal-image"
            />
            <div className="modal-actions">
              <button onClick={() => handleDownload(selectedImage)}>
                Download
              </button>
              <button onClick={() => handleShare(selectedImage)}>Share</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ImageQuote;
